import { useMemo } from "react";
import { getTranslations } from "../util/helper";
import { useAppContext } from "../context/AppContext";

function extractProductInfo(productInformation, lang, fallbackLang) {
  if (!productInformation) return {};
  const get = (field) =>
    productInformation[field]?.[lang] ||
    productInformation[field]?.[fallbackLang] ||
    [];
  return {
    ingredients: get("ingredients"),
    allergens: get("allergens"),
    nutrition_facts: get("nutrition_facts"),
    spiciness_level: get("spiciness_level"),
    features: get("features"),
  };
}

export default function useMenuData() {
  const { language, menu } = useAppContext();

  return useMemo(() => {
    if (!menu || !language) return null;
    const fallbackLang = menu.primary_language || "he";
    const lang = language;
    return {
      ...menu,
      categories: (menu.categories || []).map((category) => ({
        ...category,
        translations: getTranslations(category?.translations, lang, fallbackLang),
        items: (category?.items || []).map((item) => ({
          ...item,
          menu_item_id: item.item_id,
          id: Math.random().toString(36).substr(2, 9),
          translations: getTranslations(item?.translations, lang, fallbackLang),
          total_quantity: item.quantity,
          actual_price: item?.price,
          productInfo: extractProductInfo(item?.product_information, lang, fallbackLang),
          options: (item?.options || []).map((option) => ({
            ...option,
            name: option?.name?.[lang] || option?.name?.[fallbackLang] || option?.name,
            values: (option?.values || []).map((value) => ({
              ...value,
              name: value?.name?.[lang] || value?.name?.[fallbackLang] || value?.name,
            })),
          })),
        })),
      })),
    };
  }, [language, menu]);
}
